var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter2 = function SvgTwitter2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081B36",
    fillOpacity: 0.5,
    d: "M9.524 6.776 15.48 0H14.07L8.895 5.882 4.765 0H0l6.247 8.896L0 16h1.411l5.462-6.213L11.235 16H16M1.92 1.041H4.09l9.98 13.969H11.9"
  })));
};
export default SvgTwitter2;